import { useParams } from 'react-router-dom';
import { useIsFetching, useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@app/dashboard/constants/query-keys';
import { fetchSingleCampaign } from '@app/dashboard/services/inner_layout/reach/campaigns/singleCampaign';

import Details from './Details';
import Header from './Header';

import styles from './SingleCampaign.module.scss';

const SingleCampaign = () => {
  const { id } = useParams<{ id: string | undefined }>();
  const isFetching = useIsFetching();

  const {
    data: { data: campaignDetails } = {},
    isError: isCampaignDetailsError,
  } = useQuery({
    queryKey: [QUERY_KEYS.REACH_GET_CAMPAIGN_DETAILS, id],
    queryFn: () => fetchSingleCampaign(id as string),
    enabled: !!id,
  });

  const campaignSource =
    campaignDetails?.data?.campaigns ?? campaignDetails?.data ?? {};

  return (
    <div className={styles['single-campaign']}>
          
      <Header
        id={id}
        campaignDetails={{
          campaignDetails: campaignSource,
          isCampaignDetailsLoading: !!isFetching,
          isCampaignDetailsError,
        }}
      />
      <Details
        campaignId={id}
        campaignDetails={{
          campaignDetails: campaignSource,
          isCampaignDetailsLoading: !!isFetching,
          isCampaignDetailsError,
        }}
      />
    </div>
  );
};

export default SingleCampaign;
